// extracted by mini-css-extract-plugin
export default {"page":"SystemSettings_page__et78t","content-wrapper":"SystemSettings_content-wrapper__UH6-N"};